import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable()
export class AuthConfigService {
  private err = false;

  constructor(private readonly oauthService: OAuthService) {
    this.oauthService.setStorage(localStorage);
    this.oauthService.configure(environment.auth as AuthConfig);
  }

  public configureOAuth(): void {
    this.oauthService
      .loadDiscoveryDocumentAndTryLogin()
      .catch(() => (this.err = true));
  }

  //TODO: Use this error to notify the user about problems with connecting to OpenID Identity
  public get isConfigurationError(): boolean {
    return this.err;
  }
}
